// extracted by mini-css-extract-plugin
export default {"container":"FrequencyIntervalFilter_container__XY25C","suffix":"FrequencyIntervalFilter_suffix__AW+Bs"};